var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 640",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M140.568 362.199l168.648 76.779V73.022L140.568 165.77zM.013 193.83v140.308c0 15.499 12.562 28.063 28.093 28.063h84.339V165.77h-84.34c-15.531 0-28.092 12.561-28.092 28.06zM395.431 150.207l-32.969 31.405c15.938 16.875 24.654 38.78 24.654 62.091 0 23.249-8.718 45.124-24.654 61.998l32.969 31.468c23.093-24.375 37.277-57.279 37.277-93.466.002-36.217-14.185-69.122-37.277-93.496z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M452.709 95.49l-32.949 31.468c14.171 14.843 25.356 31.905 33.295 50.687 8.891 20.905 13.343 43.154 13.343 66.06 0 22.938-4.452 45.093-13.343 65.997-7.938 18.844-19.124 35.813-33.295 50.718l32.949 31.405c36.748-38.593 59.278-90.778 59.278-148.12 0-57.436-22.53-109.592-59.278-148.215z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIcon);
export default __webpack_public_path__ + "static/media/audio_icon.dd9932fe59e1482b81596692ac1342dc.svg";
export { ForwardRef as ReactComponent };